var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('admin-vehicles',{attrs:{"adminType":"staff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }